import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import Logo from "../components/Logo";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import api, { formatApiErrorDetail } from "../lib/api";
import BackButton from "../components/BackButton";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await api.post("/auth/reset-password", { token, password });
      setDone(true);
      setTimeout(() => navigate("/accedi"), 1800);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen paper-grain flex items-center justify-center px-6 py-12 relative">
      <BackButton className="absolute top-4 left-4" />
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center justify-center gap-2 mb-8">
          <Logo size={44} />
          <span className="font-serif text-xl font-bold text-[#0B2A45]">Guatemalan Spirits &amp; Fruit Juice</span>
        </Link>
        <div className="bg-white rounded-2xl shadow-xl border border-stone-200 p-8">
          <h1 className="font-serif text-2xl font-semibold text-[#0B2A45] mb-1">Nuova password</h1>
          {done ? (
            <p className="text-sm text-green-700 mt-4" data-testid="reset-success">
              Password reimpostata! Reindirizzamento all'accesso…
            </p>
          ) : (
            <form onSubmit={submit} className="space-y-4 mt-4">
              <div>
                <Label htmlFor="password">Nuova password</Label>
                <Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)}
                       required minLength={6} data-testid="reset-password-input" className="mt-1.5" />
              </div>
              {error && <p className="text-sm text-red-600" data-testid="reset-error">{error}</p>}
              <Button type="submit" disabled={loading || !token} data-testid="reset-submit-btn"
                      className="w-full bg-[#0F4C81] hover:bg-[#0A365C] text-white h-11 rounded-full">
                {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Reimposta password"}
              </Button>
            </form>
          )}
          <div className="mt-4 text-center">
            <Link to="/accedi" className="text-sm text-[#0F4C81] hover:underline">Torna all'accesso</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
